<template>
  <ion-page>
    <master-layout pageTitle="ورود به سیستم">
      <br/>
      <br/>
      <ion-img src="/assets/img/logo-land.png" class="login-img"></ion-img>
      <br/>
      <ion-card>
        <ion-card-content>
          <form @submit="login">
            <ion-item>
              <ion-label position="floating">نام کاربری</ion-label>
              <ion-input name="username" v-model="userInfo.username"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="floating">گذرواژه</ion-label>
              <ion-input name="password" type="password" v-model="userInfo.password"></ion-input>
            </ion-item>
            <br/>
            <ion-button expand="full" @click="login()" color="success" v-html="loginBtnText"></ion-button>
            <br/>
          </form>

          <router-link to="/forgotPassword" class="text-danger" >
            فراموشی کلمه عبور
            &nbsp;<i class="far fa-key"></i>
          </router-link>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardContent, IonItem, IonLabel, IonInput, IonPage,
  toastController, useIonRouter, useBackButton
} from "@ionic/vue";
import {mapGetters, mapActions} from "vuex";
import {useRouter} from 'vue-router';
import {showSystemNoti} from '@/shared/helper'

export default {
  components: {
    IonCard, IonCardContent, IonItem, IonLabel, IonInput, IonPage
  },
  data()
  {
    return {
      loginBtnText: '<i class="far fa-check-circle"></i>&nbsp;ورود',
      userInfo: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters("auth", {
      loginStatus: "getLoginStatus",
    }),
  },
  setup()
  {
    let backButtonTime = 0;
    const ionRouter = useIonRouter();
    useBackButton(-1, async (processNextHandler)=>
    {
      if (!ionRouter.canGoBack())
      {
        if ((new Date().getTime() - backButtonTime) < 3500)
          navigator['app'].exitApp();
        else
        {
          const toast = await toastController.create({
            header: '',
            message: 'برای خروج دکمه بازگشت را بزنید',
            duration: 2000,
            position: 'bottom',
            color: 'danger'
          });
          await toast.present();
          backButtonTime = new Date().getTime()
        }
      }
      processNextHandler();
    });
    const router = useRouter();
    return {router};
  },
  methods: {
    ...mapActions("auth", {
      loginUser: "loginUser",
    }),
    async login()
    {
      if (this.userInfo.username && this.userInfo.password)
      {
        this.loginBtnText = '<i class="fa fa-spin fa-spinner"></i>';
        const re = await this.loginUser(this.userInfo);
        if (this.loginStatus === "success")
        {
          // await this.router.push('/Dashboard')
          const toast = await toastController.create({
            header: '',
            message: 'با موفقیت وارد شدید ...',
            duration: 800,
            position: 'bottom',
            color: 'success'
          });
          await toast.present();
          setTimeout(function ()
          {
            window.location.replace('/')
          }, 1200)
        }
        else
        {
          this.loginBtnText = 'ورود'
          showSystemNoti('danger', re.error)
        }
      }
      else
      {
        showSystemNoti('danger', 'لطفا نام کاربری و گذرواژه را وارد نمایید.')
      }
    },
  },
};
</script>

<style scoped>
.login-img {
  max-width: 100%;
  width: 200px;
  margin: 0 auto;
}
</style>